import React from 'react';
import './RefundCancellation.css';

const RefundCancellation = () => {
  return (
    <section className="refund-section">
      <h2>Refund and Cancellation Policy</h2>
      <p>
        In case of any refunds approved by KAAMVALA JOBS and SERVICES, it will take 15 days for the refund to be credited to your original payment method.
      </p>
    </section>
  );
};

export default RefundCancellation;
